export const CONNECT_TEST_CASES_REQ = 'CONNECT_TEST_CASES_REQ';
export const DISCONNECT_TEST_CASES_REQ = 'DISCONNECT_TEST_CASES_REQ';

export const  SHOW_EXPECTED_RESPONSES_REQ = 'SHOW_EXPECTED_RESPONSES_REQ';
export const  HIDE_EXPECTED_RESPONSES_REQ = 'HIDE_EXPECTED_RESPONSES_REQ';
export const  SHOW_EXPECTED_RESPONSES_FOR_DIALOG_ITEM_REQ = 'SHOW_EXPECTED_RESPONSES_FOR_DIALOG_ITEM_REQ';

export const  SHOW_COMMANDS_IN_TEST_MODE_REQ = 'SHOW_COMMANDS_IN_TEST_MODE_REQ';
export const  HIDE_COMMANDS_IN_TEST_MODE_REQ = 'HIDE_COMMANDS_IN_TEST_MODE_REQ';

export const  SHOW_CODE_LINKS_REQ = 'SHOW_CODE_LINKS_REQ';
export const  HIDE_CODE_LINKS_REQ = 'HIDE_CODE_LINKS_REQ';

export const  ADD_TEXT_DIALOG_ITEM_REQ = 'ADD_TEXT_DIALOG_ITEM_REQ';
export const  UPDATE_TEXT_DIALOG_ITEM_REQ = 'UPDATE_TEXT_DIALOG_ITEM_REQ';
export const  ADD_VISUAL_STATE_DIALOG_ITEM_REQ = 'ADD_VISUAL_STATE_DIALOG_ITEM_REQ';
export const  UPDATE_VISUAL_STATE_DIALOG_ITEM_REQ = 'UPDATE_VISUAL_STATE_DIALOG_ITEM_REQ';
export const  ADD_DIALOG_ITEM_FROM_SYSTEM_MSG_REQ = 'ADD_DIALOG_ITEM_FROM_SYSTEM_MSG_REQ';
export const  ADD_DIALOG_ITEM_WITH_QR_CODE_REQ = 'ADD_DIALOG_ITEM_WITH_QR_CODE_REQ';
export const  DELETE_DIALOG_ITEM_REQ = 'DELETE_DIALOG_ITEM_REQ';

export const  CONNECT_QR_CODE_TO_TEST_DIALOG_REQ = 'CONNECT_QR_CODE_TO_TEST_DIALOG_REQ';
export const  HIDE_QR_CODE_POPUP_REQ = 'HIDE_QR_CODE_POPUP_REQ';
export const  DEVICE_CONNECTED_BY_QR_CODE_REQ = 'DEVICE_CONNECTED_BY_QR_CODE_REQ';
export const  DEVICE_CONNECTED_BY_QR_CODE_OK = 'DEVICE_CONNECTED_BY_QR_CODE_OK';
export const  DEVICE_DISCONNECTED_BY_QR_CODE_REQ = 'DEVICE_DISCONNECTED_BY_QR_CODE_REQ';
export const  DEVICE_DISCONNECTED_BY_QR_CODE_OK = 'DEVICE_DISCONNECTED_BY_QR_CODE_OK';

export const  ADD_DIALOG_REQ = 'ADD_DIALOG_REQ';

export const  COPY_DIALOG_REQ = 'COPY_DIALOG_REQ';
export const  COPY_DIALOG_OK = 'COPY_DIALOG_OK';

export const  PASTE_DIALOG_REQ = 'PASTE_DIALOG_REQ';

export const  DELETE_DIALOG_REQ = 'DELETE_DIALOG_REQ';

export const  CHANGE_DIALOG_ORDER_REQ = 'CHANGE_DIALOG_ORDER_REQ';

export const  REFRESH_PHRASES_REQ = 'REFRESH_PHRASES_REQ';
export const  REFRESH_PHRASES_OK = 'REFRESH_PHRASES_OK';

export const  REFRESH_DIALOGS_IN_CONVERSATION_REQ = 'REFRESH_DIALOGS_IN_CONVERSATION_REQ';
export const  REFRESH_DIALOGS_IN_CONVERSATION_OK = 'REFRESH_DIALOGS_IN_CONVERSATION_OK';

export const  REFRESH_ALL_DIALOGS_REQ = 'REFRESH_ALL_DIALOGS_REQ';
export const  REFRESH_ALL_DIALOGS_OK = 'REFRESH_ALL_DIALOGS_OK';

export const  COLLECT_DIALOG_INFO_REQ = 'COLLECT_DIALOG_INFO_REQ';
export const  COLLECT_DIALOG_INFO_OK = 'COLLECT_DIALOG_INFO_OK';

export const  STOP_REFRESHING_ALL_DIALOGS_REQ = 'STOP_REFRESHING_ALL_DIALOGS_REQ';
export const  STOP_REFRESHING_ALL_DIALOGS_OK = 'STOP_REFRESHING_ALL_DIALOGS_OK';

export const  STOP_REFRESHING_ONE_DIALOG_REQ = 'STOP_REFRESHING_DIALOG_REQ';

export const  STOP_REFRESHING_DIALOG_REQ = 'STOP_REFRESHING_DIALOG_REQ';
export const  STOP_REFRESHING_DIALOG_OK = 'STOP_REFRESHING_DIALOG_OK';

export const  UPDATE_REFRESH_ALL_DIALOGS_COUNTER_OK = 'UPDATE_REFRESH_ALL_DIALOGS_COUNTER_OK';

export const  START_REFRESHING_DIALOG_COUNTER_OK = 'START_REFRESHING_DIALOG_COUNTER_OK';
export const  UPDATE_REFRESHING_DIALOG_COUNTER_OK = 'UPDATE_REFRESHING_DIALOG_COUNTER_OK';
export const  FINISH_REFRESHING_DIALOG_COUNTER_OK = 'FINISH_REFRESHING_DIALOG_COUNTER_OK';

export const  ADD_EXPECTED_RESPONSE_REQ = 'ADD_EXPECTED_RESPONSE_REQ';
export const  COPY_EXPECTED_RESPONSE_REQ = 'COPY_EXPECTED_RESPONSE_REQ';
export const  COPY_EXPECTED_RESPONSE_OK = 'COPY_EXPECTED_RESPONSE_OK';
export const  PASTE_EXPECTED_RESPONSE_REQ = 'PASTE_EXPECTED_RESPONSE_REQ';
export const  CHANGE_EXPECTED_RESPONSE_CONDITION_REQ = 'CHANGE_EXPECTED_RESPONSE_CONDITION_REQ';
export const  EDIT_EXPECTED_RESPONSE_REQ = 'EDIT_EXPECTED_RESPONSE_REQ';
export const  DELETE_EXPECTED_RESPONSE_REQ = 'DELETE_EXPECTED_RESPONSE_REQ';
export const  DELETE_ALL_EXPECTED_RESPONSES_REQ = 'DELETE_ALL_EXPECTED_RESPONSES_REQ';

export const  UPDATE_DIALOG_CONTENT_REQ = 'UPDATE_DIALOG_CONTENT_REQ';
export const  UPDATE_DIALOG_CONTENT_OK = 'UPDATE_DIALOG_CONTENT_OK';

export const MARK_DIALOG_ACTUAL_REQ = 'MARK_DIALOG_ACTUAL_REQ';

export const GET_DIALOGS_CONTENT_REQ = 'GET_DIALOGS_CONTENT_REQ';
export const GET_DIALOGS_CONTENT_OK = 'GET_DIALOGS_CONTENT_OK';

export const UPDATE_TEST_PHRASES_REQ = 'UPDATE_TEST_PHRASES_REQ';
export const UPDATE_TEST_PHRASES_OK = 'UPDATE_TEST_PHRASES_OK';

export const STOP_AUDIO_IN_TEST_MODE_REQ = 'STOP_AUDIO_IN_TEST_MODE_REQ';

export const GENERATE_QR_CODE_REQ = 'GENERATE_QR_CODE_REQ';